import React from "react";
import { SectionHeader } from "./SectionHeader";

export const Industries = ({ data, section }) => {
  const s = section || {};
  if (!data) return null;
  return (
    <div id="industries" className="text-center">
      <div className="container">
        <SectionHeader heading={s.heading} subheading={s.subheading} />
        <div className="row">
          {data.map((d, i) => (
            <div key={i} className="col-md-4 industry-card">
              <i className={d.icon}></i>
              <h3>{d.title}</h3>
              <p>{d.text}</p>
              {d.highlights.map((h, j) => (
                <div key={j} className="industry-highlight">
                  <i className="fa fa-check-circle"></i> {h.text}
                </div>
              ))}
            </div>
          ))}
        </div>
        <div className="row" style={{ marginTop: "30px" }}>
          {s.closing_line && <p>{s.closing_line}</p>}
          {s.cta_label && (
            <a
              href={s.cta_href || "#contact"}
              className="btn btn-custom btn-lg page-scroll"
            >
              {s.cta_label}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};
